import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    pendingOpenKeyModal: false,
    pendingOpenCabinetWinCriteria: false,
  }),
  actions: {
    requestOpenKeyModal() {
      this.pendingOpenKeyModal = true
    },
    consumeOpenKeyModal() {
      const v = this.pendingOpenKeyModal
      this.pendingOpenKeyModal = false
      return v
    },
    requestOpenCabinetWinCriteria() {
      this.pendingOpenCabinetWinCriteria = true
    },
    consumeOpenCabinetWinCriteria() {
      const v = this.pendingOpenCabinetWinCriteria
      this.pendingOpenCabinetWinCriteria = false
      return v
    },
  },
})
